import React, { useState } from "react";
import { Text, View, TextInput, Button, Alert } from "react-native";
import { AppFontStyle } from "../../styles/AppFontStyle";
import { AppColors } from "../../utility/AppColors";
import { TouchableOpacity } from "react-native-gesture-handler";
import { CommonButton } from "../../common/CommonButton";
import { toast } from "react-toastify";

const HelpCenterContactUsComponent = ({ topData, bottomData }) => {
  const [form, setForm] = useState({ name: "", issue: "" });
  const [errors, setErrors] = useState({ name: "", issue: "" });

  const validateForm = () => {
    let valid = true;
    let nameError = "",
      issueError = "";

    if (!form.name.trim()) {
      nameError = "Name is required.";
      valid = false;
    }

    if (!form.issue.trim()) {
      issueError = "Issue description is required.";
      valid = false;
    }

    setErrors({ name: nameError, issue: issueError });
    return valid;
  };

  const handleSubmit = () => {
    if (validateForm()) {
      toast.success(
        "Thanks for reaching out! Our support team has received your message and will get back to you shortly."
      );

      console.log("Form submitted:", {
        name: form.name,
        issue: form.issue,
      });

      setForm({ name: "", issue: "" });
      setErrors({ name: "", issue: "" });
    }
  };

  return (
    <View>
      {topData && topData.length > 0 && (
        <View>
          {topData.map((text, index) => (
            <Text
              key={`top-${index}`}
              style={[AppFontStyle.REGULAR_ANYBODY_12, { marginBottom: 10 }]}
            >
              {text}
            </Text>
          ))}
        </View>
      )}

      <View
        style={{
          marginTop: 0,
          marginBottom: bottomData && bottomData.length > 0 ? 25 : 0,
          borderWidth: 1,
          borderColor: "rgb(58, 81, 117)",
          paddingVertical: 10,
          borderRadius: 5,
        }}
      >
        <TextInput
          placeholder="Name"
          value={form.name}
          onChangeText={(text) => setForm({ ...form, name: text })}
          style={{
            borderWidth: 1,
            borderColor: AppColors.gray_6E90B4,
            padding: 10,
            borderRadius: 5,
            color: AppColors.gray_7B7B7B,
            backgroundColor: AppColors.grayColor_D9D9D9,
            marginBottom: 10,
          }}
          placeholderTextColor={AppColors.gray_7B7B7B}
        />
        {errors.name ? (
          <Text
            style={{
              color: "red",
              fontSize: 12,
              marginBottom: 10,
              fontWeight: 700,
            }}
          >
            {errors.name}
          </Text>
        ) : null}

        <TextInput
          placeholder="Describe Your Issue: Provide as much detail as possible so we can assist you effectively."
          value={form.issue}
          onChangeText={(text) => setForm({ ...form, issue: text })}
          style={{
            borderWidth: 1,
            borderColor: AppColors.gray_6E90B4,
            padding: 10,
            borderRadius: 5,
            color: AppColors.gray_7B7B7B,
            backgroundColor: AppColors.grayColor_D9D9D9,
            height: 100,
            marginBottom: 10,
          }}
          placeholderTextColor={AppColors.gray_7B7B7B}
          multiline
        />
        {errors.issue ? (
          <Text
            style={{
              color: "red",
              fontSize: 12,
              marginBottom: 10,
              fontWeight: 700,
            }}
          >
            {errors.issue}
          </Text>
        ) : null}

        <View style={{ alignItems: "flex-end" }}>
          <CommonButton
            title="Send"
            onTap={handleSubmit}
            buttonStyle={{
              padding: 0,
              width: 100,
              backgroundColor: AppColors.appViolentColor_6D08C3,
              borderRadius: 10,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.25)",
            }}
            textStyle={[
              AppFontStyle.BOLD_ANYBODY_12,
              {
                paddingVertical: 12,
                paddingHorizontal: 18,
              },
            ]}
          />
        </View>
      </View>

      {bottomData && bottomData.length > 0 && (
        <View>
          {bottomData.map((text, index) => (
            <Text
              key={`bottom-${index}`}
              style={[AppFontStyle.REGULAR_ANYBODY_12, { marginBottom: 10 }]}
            >
              {text}
            </Text>
          ))}
        </View>
      )}
    </View>
  );
};

export default HelpCenterContactUsComponent;
